import React, {useEffect, useRef, useState} from 'react'
import Select from 'react-select'
import {getAllRefusMotif} from '../../../../../components/requests'
import {ModeleMotif} from '../../../../../components/Models'
import {KTSVG} from '../../../../../_metronic/helpers'

type handleStatusProps = {
  handleStatus: (id: any, status: boolean, idMotif: number) => void
  setSelectedMotif: any
  selectedMotif: any
  pieceId: any
}

const MotifModal = ({
  handleStatus,
  setSelectedMotif,
  selectedMotif,
  pieceId,
}: handleStatusProps) => {
  const [motifs, setMotifs] = useState<Array<ModeleMotif>>([])
  const [isLoading, setIsLoading] = useState<boolean>(false)
  const modalRef = useRef<HTMLDivElement | null>(null)

  const getAllMotif = () => {
    setIsLoading(true)
    getAllRefusMotif().then((res) => {
      if (res?.status === 200 && res?.data !== undefined) {
        const transfromedData = res.data.map((item) => ({
          value: item.id,
          label: item.libelle,
        }))
        setMotifs([...transfromedData])
        setIsLoading(false)
      } else {
        console.error('Erreur lors de la récupération de données')
      }
    })
  }

  const handleMotifChange = (e) => {
    setSelectedMotif(e)
  }

  useEffect(() => {
    const modal = modalRef.current
    // A executer lors de l'affichage du modal
    if (modal) {
      modal.addEventListener('shown.bs.modal', () => {
        getAllMotif()
      })
    }

    return () => {
      if (modal) {
        modal.removeEventListener('shown.bs.modal', () => {})
      }
    }
  }, [])

  return (
    <div className='modal fade' tabIndex={-1} id='kt_modal_refus' ref={modalRef}>
      <div className='modal-dialog'>
        <div className='modal-content'>
          <div className='modal-header'>
            <h5 className='modal-title'>Motif de refus</h5>
            <div
              className='btn btn-icon btn-sm btn-active-light-primary ms-2'
              data-bs-dismiss='modal'
              aria-label='Close'
            >
              <KTSVG
                path='/media/icons/duotune/arrows/arr061.svg'
                className='svg-icon svg-icon-2x'
              />
            </div>
          </div>
          <div className='modal-body'>
            <Select
              className='react-select-styled react-select-solid react-select-lg'
              classNamePrefix='react-select'
              options={motifs}
              fieldName='motif_refus'
              isLoading={isLoading}
              value={selectedMotif?.label}
              onChange={(e) => handleMotifChange(e.value)}
              placeholder='Sélectionner un motif'
            />
          </div>
          <div className='modal-footer'>
            <button
              type='button'
              className='btn btn-light'
              data-bs-target='#kt_modal_1'
              data-bs-toggle='modal'
            >
              Retour
            </button>
            <button
              type='button'
              className='btn btn-danger'
              data-bs-toggle='modal'
              data-bs-target='#kt_modal_1'
              onClick={() => handleStatus(pieceId, false, selectedMotif)}
              disabled={!motifs.length}
            >
              Refuser
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default MotifModal
